import { DEFAULT_HUB_TEXT_SIZE, SCALE_BY_SIZE, type HubTextSize } from './appTheme';

/** Last size passed to {@link applyHubTextSize} (in-memory; survives drawer remounts). */
let appliedHubTextSize: HubTextSize = DEFAULT_HUB_TEXT_SIZE;

/**
 * Applies hub text size to the document root.
 * Sets `--app-font-scale` and `html` font-size percent (Settings UI contract).
 */
export function applyHubTextSize(size: HubTextSize): void {
	appliedHubTextSize = size;

	if (typeof document === 'undefined') {
		return;
	}

	const scale = SCALE_BY_SIZE[size];
	const root = document.documentElement;
	root.style.setProperty('--app-font-scale', String(scale));
	root.style.fontSize = `${scale * 100}%`;
}

/** Returns the currently applied hub text size (does not read Preferences). */
export function getAppliedHubTextSize(): HubTextSize {
	return appliedHubTextSize;
}
